import { createContext } from '@lit/context'

import {} from '../types.js'
import { Mapping, TreeNode } from '../types.js'

export interface DataMapperContextType {
  getUniqueId: () => string
  getNodePosition: (nodeId: string, source: boolean) => { x: number; y: number } | undefined
  updateMappings: (mappings: Mapping[]) => void
}

export const dataMapperContext = createContext<DataMapperContextType>('data-mapper-context')
